import { render, staticRenderFns } from "./ImageProcessing.vue?vue&type=template&id=efc08ec0&"
import script from "./ImageProcessing.vue?vue&type=script&lang=js&"
export * from "./ImageProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports